import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Resolve the current principal's role posture. Returns:
 *  - `isAdmin`: legacy admin cookie OR User.role === 'admin'. Sees the full
 *               operator UI including Phases, Logs, Teardown, secret-sauce
 *               internals.
 *  - `isOperator`: User.role === 'operator'. Workspace owner — sees a
 *                  simplified product surface.
 *  - `loaded`: false while the /api/users/me query is in flight.
 *
 * Anonymous callers / tokens that don't carry a role land in the admin
 * branch by default — they shouldn't be inside the operator app at all
 * (OperatorGuard catches that), so this is a safe fallback.
 */
export function useRole() {
  const q = useQuery({ queryKey: ['users-me'], queryFn: api.userMe, retry: false, staleTime: 30_000 });
  const m: any = q.data;
  const loaded = !q.isLoading;
  const hasRole = !!m && 'role' in m;
  const isAdmin = !hasRole || m.role === 'admin';
  const isOperator = hasRole && m.role === 'operator';
  return { isAdmin, isOperator, loaded };
}
